'use strict';

const trackingUtils = require('../modules/utils/tracking.utils');

let popupMode = 'default';
const trackingCode = {
    BO_SB: 'small',
    BO_PB: 'priority',
    BO_HB: '10kg',
    NA: 'NA',
};
const ONE_CLICK = 'one-click';

const setPopupMode = function(mode) {
    popupMode = mode;
};

const getPopupMode = function() {
    return popupMode;
};

const getTypeTrackingConstant = function(type) {
    return trackingCode[type];
};

const getSelectedTypeTrackingConstant = function(data) {
    return getTypeTrackingConstant(data.selectedType);
};

const trackBoardingOptionAllSections = function(data) {
    sendTrack({
        action: 'on_load_widgets',
        prefix: ['cabin_bag_appearances-', getSelectedTypeTrackingConstant(data), '_legs'].join(''),
        data: data,
    });
};

const trackBoardingOptionAttention = function(data) {
    if (data.priorityOptionsEnabledForAllSections && data.selectedType === 'BO_SB') {
        sendTrack({
            action: 'on_load_message',
            prefix: 'cabin_bag_message_appearances_legs',
            data: data,
        });
    }
};

const trackBoardingOptionsOpenButton = function(data) {
    sendTrack({
        action: 'cabin_bag_widget',
        prefix: ['cabin_bag_widget_open-', getSelectedTypeTrackingConstant(data), '_legs'].join(''),
        data: data,
    });
};

const trackingBoardingOptionsShowPopup = function(data) {
    sendTrack({
        action: 'cabin_bag_' + popupMode,
        prefix: ['cabin_bag_', popupMode, '_appearances-', getSelectedTypeTrackingConstant(data), '_legs'].join(''),
        data: data,
        suffix: [
            '_prod:',
            isOptionAvailable('BO_SB', data, 'S'),
            '-',
            isOptionAvailable('BO_SB', data, 'P'),
            '-',
            isOptionAvailable('BO_HB', data, 'C'),
        ].join(''),
    });
};

const trackingBoardingOptionsPopupButton = function(data) {
    sendTrack({
        action: 'cabin_bag_' + popupMode,
        prefix: ['cabin_bag_', popupMode, '_select-', getTypeTrackingConstant(data.selected), '_legs'].join(''),
        data: data,
    });
};

const trackingBoardingOptionsPopupClose = function(data) {
    sendTrack({
        action: 'cabin_bag_' + popupMode,
        prefix: ['cabin_bag_', popupMode, '_close-', getSelectedTypeTrackingConstant(data), '_legs'].join(''),
        data: data,
    });
};

const trackingBoardingOptionsContinue = function(data) {
    const carrierNumber = Odigeo._.get(data, 'carrierNumber', 0);
    let widgetName = 'cabin_bag-';
    let zParam = '';
    if (Odigeo.AB.isCabinBagsRevampDesktop || Odigeo.AB.isCabinBagsRevampMobile) {
        zParam = ONE_CLICK+'-';
        widgetName = 'cabin_bag_widget:';
    }


    if (carrierNumber > 0) {
        sendTrack({
            action: 'cabin_bag',
            prefix: [widgetName, zParam, popupMode, '_selected-', getSelectedTypeTrackingConstant(data), '_legs'].join(''),
            data: data,
            suffix: ['_pag:', data.page].join(''),
        });
    }
};

const trackOnPaxLoad = () => {
    trackingUtils.trackEvent('on_load_widgets', 'cabin_bag_appearances');
};

const sendTrack = function(params) {
    trackingUtils.trackEvent(params.action, buildLabel(params));
};

const isOptionAvailable = function(option, data, trueValue) {
    return Odigeo._.get(data, ['collection', option, 'available']) ? trueValue : '0';
};

const buildLabel = function(params) {
    const prefix = Odigeo._.get(params, 'prefix', '');
    const suffix = Odigeo._.get(params, 'suffix', '');
    const totalNumber = Odigeo._.get(params, 'data.totalNumber', '');
    const carrier = Odigeo._.get(params, 'data.carrier', '');
    const carrierNumber = Odigeo._.get(params, 'data.carrierNumber', '');
    const isPrimeAB = Odigeo._.get(params, 'data.isPrimeAB', '');
    const maxdsc = Odigeo._.get(params, 'data.maxdsc', '');

    let label = `${prefix}:${totalNumber}`;
    if (carrierNumber) {
        label += `-${carrierNumber}`;
    }

    if (isPrimeAB && maxdsc) {
        label += `_maxdsc:${maxdsc}`;
    }
    if (carrier) {
        label += `_carrier:${carrier}`;
    }

    label += suffix;

    return label;
};

module.exports = {
    setPopupMode,
    getPopupMode,
    getTypeTrackingConstant,
    getSelectedTypeTrackingConstant,
    trackBoardingOptionAllSections,
    trackBoardingOptionAttention,
    trackBoardingOptionsOpenButton,
    trackingBoardingOptionsShowPopup,
    trackingBoardingOptionsPopupButton,
    trackingBoardingOptionsPopupClose,
    trackingBoardingOptionsContinue,
    trackOnPaxLoad,
    buildLabel,
};
